import { Button } from 'antd';
import { AlignCenterOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

const AlignCenter = ({ editor, showLabel = false }) => {
  return (
    <Button
      className={`editor-toolbar-btn-container ${editor.isActive({ textAlign: 'center' }) ? '!bg-slate-100 text-black' : '!bg-transparent'}`}
      icon={<AlignCenterOutlined className="text-gray-800 text-xs" />}
      onClick={() => editor.chain().focus().setTextAlign('center').run()}
      size="small"
      type="text"
    >
      {showLabel && (
        <div className="editor-toolbar-btn-label">
          <FormattedMessage id="ALIGN_CENTER" defaultMessage="Align center" />
        </div>
      )}
    </Button>
  );
};

export default AlignCenter;
